import type { SVGProps } from 'react'

interface CircleExclamationIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}

/**
 * Circle with exclamation mark icon - commonly used for error/warning states
 */
export const CircleExclamationIcon = ({
  size = 20,
  className = 'size-5 text-danger-text',
  ...props
}: CircleExclamationIconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <circle cx='10' cy='10' r='9' stroke='currentColor' strokeWidth='2' />
      <line
        x1='10'
        y1='6'
        x2='10'
        y2='12'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <circle cx='10' cy='15' r='1' fill='currentColor' />
    </svg>
  )
}
